const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyOTkwLCJjb25ncmVzc0lkIjoxNjI0LCJkYXRlIjoiMjAyNS0wNi0xN1QxMzowNTo0MS45NjlaIiwiaWF0IjoxNzUwMTY1NTQxfQ.55Hqv6J6k10tQMIsq23W-tYXjH7QYMNgI5ma5Jdq8NI';
const PLANNER_API_URL = 'https://sgaimfk2026.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyNDA3LCJjb25ncmVzc0lkIjoxNTI0LCJkYXRlIjoiMjAyNC0wNy0wOVQxMjo1OToyNy4xNjNaIiwiaWF0IjoxNzIwNTI5OTY3fQ.bmHM24HwikciPWrgMopPlqS91YmqXCE3dPx_VWhxJ5Q';
// const PLANNER_API_URL = 'http://127.0.0.1:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1624;
// const SUBMISSION_SYSTEM_URL = 'https://sgaimfk2026.abstract.documedias.systems/api/v1/export/transformed/filtered/single/abstract/{{id}}/planner/export';

const SUBMISSION_API_URL = 'https://sgaimfk2026.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}